var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportViolation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.519,
    height: 24.257,
    viewBox: "0 0 26.519 24.257",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(-35.221 28.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M35.221-9.507a8.227,8.227,0,0,1,1.361-3.209c.5-.857.994-1.717,1.49-2.576Q41.2-20.7,44.322-26.117a4.768,4.768,0,0,1,3.357-2.439,4.621,4.621,0,0,1,4.635,1.925c.981,1.583,1.893,3.209,2.826,4.821q2.949,5.1,5.889,10.2a4.771,4.771,0,0,1,.6,3.508,4.751,4.751,0,0,1-4.7,3.727c-2.5.008-5.008,0-7.512,0q-4.676,0-9.352,0A4.641,4.641,0,0,1,36.312-6.1a4.729,4.729,0,0,1-1.046-2.385c-.01-.067-.03-.132-.046-.2ZM48.439-6.516q4.2,0,8.391,0a2.694,2.694,0,0,0,1.825-.605,2.59,2.59,0,0,0,.541-3.391q-3.27-5.67-6.545-11.336c-.677-1.172-1.331-2.359-2.05-3.505a2.37,2.37,0,0,0-2.376-1.114,2.53,2.53,0,0,0-2.03,1.38q-3.306,5.738-6.625,11.469c-.651,1.127-1.325,2.243-1.934,3.393A2.4,2.4,0,0,0,37.8-7.67a2.549,2.549,0,0,0,2.3,1.155Q44.27-6.519,48.439-6.516Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M211.8,82.089l-.314,5.409a6.223,6.223,0,0,1-.05.772.994.994,0,0,1-.986.793.952.952,0,0,1-.982-.819c-.079-.693-.1-1.392-.147-2.089-.085-1.368-.161-2.737-.253-4.105a1.441,1.441,0,0,1,1.563-1.643,1.343,1.343,0,0,1,1.168,1.229C211.812,81.781,211.8,81.928,211.8,82.089Z",
    transform: "translate(-161.972 -101.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M209.6,222.381a1.367,1.367,0,0,1,1.378-1.348,1.358,1.358,0,0,1-.02,2.715A1.36,1.36,0,0,1,209.6,222.381Z",
    transform: "translate(-162.468 -232.614)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportViolation);
export default __webpack_public_path__ + "static/media/report_violation.2d3f039437b4b40a92ac65bda5517417.svg";
export { ForwardRef as ReactComponent };